import { ElementRef, Directive, Input, OnDestroy, OnInit, ViewContainerRef, ComponentRef } from '@angular/core';
import { FormGroupDirective, NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MessageCtrolComponent } from '../components/message-ctrol/message-ctrol.component';
import { Message } from '../models';

@Directive({
    selector: '[validCtrl]',
})
export class ValidCtrlDirective implements OnInit, OnDestroy {
    subscriptions: Subscription = new Subscription();
    @Input('messagesControl') messagesControl?: Array<Message>;

    private ref?: ComponentRef<MessageCtrolComponent>;
    private parentElement: HTMLElement = this.el.nativeElement.parentElement;
    private messagesDefault: Array<Message> = [
        { key: 'required', message: 'Este campo es obligatorio <br/>' },
        { key: 'minlength', message: 'La longitud mínima no se cumple <br/>' },
        { key: 'maxlength', message: 'La longitud máxima se ha excedido <br/>' },
        { key: 'email', message: 'Dirección de correo electrónico no válida <br/>' },
        { key: 'pattern', message: 'El formato no coincide con el patrón requerido <br/>' },
        { key: 'min', message: 'El valor es menor que el mínimo permitido <br/>' },
        { key: 'max', message: 'El valor es mayor que el máximo permitido <br/>' },
        { key: 'requiredTrue', message: 'Este campo debe ser verdadero <br/>' },
        { key: 'nullValidator', message: 'El valor no puede ser nulo <br/>' },
        { key: 'maxLength', message: 'La longitud máxima se ha excedido <br/>' },
        { key: 'minLength', message: 'La longitud mínima no se cumple <br/>' },
        { key: 'notmach', message: 'La confirmación no coincide <br/>' },
        { key: 'ethnicGroupConflict', message: 'Opción no válida si elegiste "Grupos étnicos"<br/>' },
        { key: 'invalidHour', message: 'La hora seleccionada ya ha pasado.<br/>Por favor, elija una hora futura.<br/>' },
        { key: 'fechaInvalida', message: 'La fecha u hora final no puede ser anterior al inicio <br/>' },
        // Mensajes para el validador de archivo PDF
        { key: 'invalidType', message: 'El archivo debe estar en formato PDF <br/>' },
        { key: 'maxSizeExceeded', message: 'El archivo no debe superar los 750KB <br/>' },
    ];
    private currentStatus: string = '';

    constructor(private el: ElementRef, private control: NgControl, private viewContainerRef: ViewContainerRef, private formGroupDirective: FormGroupDirective) {}
    ngOnInit(): void {
        this.subscriptions.add(
            this.control.statusChanges?.subscribe((value) => {
                this.currentStatus = value;
                this.validControl();
            })
        );
        this.subscriptions.add(
            this.formGroupDirective.ngSubmit.subscribe((response) => {
                this.control.control?.markAsTouched();
                this.validControl();
            })
        );
    }
    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
    validControl() {
        if (this.control.invalid && (this.control.touched || this.control.dirty)) {
            const { errors } = this.control;
            if (errors) {
                const error = Object.keys(errors)[0];
                let messageControl = this.messagesControl?.find((mess) => mess.key === error)?.message || this.messagesDefault.find((mess) => mess.key === error)?.message;
                const message = messageControl || 'Error sin mensaje';
                this.setMessageCtrl(message);
                return false;
            }
            this.setMessageCtrl();
            return true;
        } else {
            this.setMessageCtrl();
            return true;
        }
    }
    private setMessageCtrl(text?: string): void {
        if (text) {
            if (!this.ref) {
                this.ref = this.viewContainerRef.createComponent(MessageCtrolComponent);
                this.parentElement.classList.add('control-error');
            }
            this.ref.instance._text = text;
        } else {
            if (this.ref) {
                this.viewContainerRef.clear();
                this.ref = undefined;
                this.parentElement.classList.remove('control-error');
            }
        }
    }
}
